import React from 'react';

import { LayoutRenderer } from './types';

const SECONDARY_SLOTS = 6;

export const SquareGrid3x2Layout: LayoutRenderer = ({ children }) => {
  const nodes = React.Children.toArray(children).filter(Boolean);
  const [first, ...rest] = nodes;
  const secondaryTiles = rest.slice(0, SECONDARY_SLOTS);

  if (!first) return null;

  return (
    <div className="itv-row-collection__square-grid-3x2">
      <div className="itv-row-collection__square-grid-3x2-primary">{first}</div>
      <div className="itv-row-collection__square-grid-3x2-secondary">
        {secondaryTiles.map((tile, index) => (
          <div key={`square-grid-3x2-secondary-cell-${index}`} className="itv-row-collection__square-grid-3x2-cell">
            {tile}
          </div>
        ))}
      </div>
    </div>
  );
};
